// Utilidades de normalización de texto para búsquedas insensibles a tildes
// y mayúsculas. "María" matchea "maria" y viceversa.

// t400 (22-oct-2026) · LA FUNCIÓN COMÚN DE LOS BUSCADORES. El dueño: al dar una cita, «extraccion» tiene que encontrar
// «EXTRACCIÓN DENTAL», «tartrectomia» «TARTRECTOMÍA» y «fluor» o «flúor» «APLICACIÓN TÓPICA DE FLÚOR». Todos los
// buscadores de tratamientos y fases comparan con `norm` en los DOS lados (lo escrito y lo que se busca):
//   · minúsculas;
//   · sin tildes: NFD y fuera los diacríticos (U+0300..U+036F), así que la ñ queda n, la ü queda u y la ç queda c;
//   · los espacios de más (dobles, tabuladores, el duro U+00A0) quedan en uno, y sin espacios al principio ni al final.
// La guardia backend/routes/buscar-tratamientos-sin-tildes.test.js monta los buscadores de verdad con y sin tilde.
export function norm(s) {
  if (s == null) return ''
  return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim()
}

// Comprueba si `text` contiene `query` ignorando tildes, mayúsculas y espacios de más. Sin nada escrito, casa.
export function matches(text, query) {
  const q = norm(query)
  if (!q) return true
  return norm(text).includes(q)
}

// Si ALGUNO de los textos contiene lo escrito (por subcadena, con `norm` en los dos lados). Sin nada escrito, casa.
export function casaAlguno(textos, query) {
  const q = norm(query)
  if (!q) return true
  return (Array.isArray(textos) ? textos : [textos]).some((t) => norm(t).includes(q))
}

// Convierte notas RTF de Gesden a texto plano legible.
// IDEMPOTENTE Y SEGURA: si la entrada no es RTF (no empieza por \rtf), la devuelve
// TAL CUAL — no toca texto normal, null ni cadenas vacías.
export function stripRtf(input) {
  if (input == null) return ''
  let s = String(input)
  if (!/^\s*{?\\rtf/i.test(s)) return s            // no es RTF → devolver intacto

  // 1) Grupos de control sin texto visible (fonttbl, colortbl, destinos \*…)
  s = s.replace(/\{\\\*[^{}]*\}/g, '')
  s = s.replace(/\{\\(fonttbl|colortbl|stylesheet|info|pict|header|footer)[^{}]*\}/gi, '')
  // 2) Saltos / tabs
  s = s.replace(/\\par[d]?(?![a-z])/gi, '\n')
  s = s.replace(/\\(line|sect|page)(?![a-z])/gi, '\n')
  s = s.replace(/\\tab(?![a-z])/gi, '\t')
  // 3) Caracteres escapados \'xx (hex, Windows-1252/Latin-1)
  s = s.replace(/\\'([0-9a-fA-F]{2})/g, (_, h) => {
    const code = parseInt(h, 16)
    try { return decodeURIComponent('%' + h) } catch { return String.fromCharCode(code) }
  })
  // 4) \uNNNN? unicode
  s = s.replace(/\\u(-?\d+)\??/g, (_, n) => String.fromCharCode(((+n) + 65536) % 65536))
  // 5) Llaves/barras escapadas literales
  s = s.replace(/\\([{}\\])/g, '$1')
  // 6) Resto de control words con/sin parámetro (\b, \fs20, \cf1…)
  s = s.replace(/\\[a-zA-Z]+-?\d* ?/g, '')
  // 7) Llaves de agrupación sobrantes
  s = s.replace(/[{}]/g, '')
  // 8) Limpieza final
  return s.replace(/\r/g, '')
          .replace(/[ \t]+\n/g, '\n')
          .replace(/\n{3,}/g, '\n\n')
          .trim()
}
